import { RestClient } from "./restClient";

export class SpotlightService {
	constructor(options) {
		this._options = options;
		this._restClient = new RestClient();
	}

	/**
	 * Create a spotlight instance
	 * @param {object} spotlight
	 * @param {function} callback
	 */
	create(spotlight, callback) {
		const url = "/ecosystem/api/spotlight";
		const body = JSON.stringify({
			spotlight
		});
		this._restClient.exec_post(url, body, callback);
	}

	/**
	 * Update a spotlight instance
	 * @param {string} spotlightId
	 * @param {object} spotlight
	 * @param {function} callback
	 */
	update(spotlightId, spotlight, callback) {
		const url = `/ecosystem/api/spotlight/${spotlightId}`;
		const body = JSON.stringify({
			spotlight
		});
		this._restClient.exec_put(url, body, callback);
	}

	/**
	 * Delete (mark as completed) a spotlight instance
	 * @param {string} spotlightId
	 * @param {function} callback
	 */
	delete(spotlightId, callback) {
		const url = `/ecosystem/api/spotlight/${spotlightId}`;
		this._restClient.exec_delete(url, callback);
	}

	/**
	 * Get all active spotlights owned by a user
	 * Used to restart active spotlights if a user navigates away,
	 * the user refreshes, or the browser crashes
	 * @param {function} callback
	 */
	getAllActive(callback) {
		const url = "/ecosystem/api/spotlight";
		this._restClient.exec_get(url, callback);
	}
}
